// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"btn-info_btnWrap_1dRZk","text":"btn-info_text_PGyaZ","icon":"btn-info_icon_dzf4T","mask":"btn-info_mask_1gUmi"};